var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272 48C280.8 48 288 55.16 288 64C288 72.84 280.8 80 272 80H16C7.164 80 0 72.84 0 64C0 55.16 7.164 48 16 48H272zM432 176C440.8 176 448 183.2 448 192C448 200.8 440.8 208 432 208H16C7.164 208 0 200.8 0 192C0 183.2 7.164 176 16 176H432zM0 320C0 311.2 7.164 304 16 304H272C280.8 304 288 311.2 288 320C288 328.8 280.8 336 272 336H16C7.164 336 0 328.8 0 320zM432 432C440.8 432 448 439.2 448 448C448 456.8 440.8 464 432 464H16C7.164 464 0 456.8 0 448C0 439.2 7.164 432 16 432H432z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.c0056b68c3f7d7fbe429b4ec270ee76c.svg";
export { ForwardRef as ReactComponent };